import React from "react";
import { Dialog } from "@mui/material";
import { MdTaskAlt } from "react-icons/md";

const ConfirmWithdrawReqModal = ({ open, onClose, data, handleRequest }) => {
    
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: "20px",
                    width: "320px",
                    position: "relative",
                },
            }}
        >
            <div className="flex justify-end items-center w-full pr-4 pt-4">
                <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 sm:h-6 sm:w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <div className="bg-white p-7 pt-5 flex flex-col gap-5 rounded-2xl text-center">

                <span
                    className="rounded-full mx-auto p-4"
                    style={{
                        background: "linear-gradient(to right,#EF5A24 1%, #F38157 99%)",
                    }}
                >
                    <MdTaskAlt color="white" size={35} />
                </span>

                <div>
                    <div className="text-[20px] font-[600] mb-2">Confirm Action</div>
                    <p className="text-sm text-gray-700">
                        Are you sure you want to process withdrawal request for <strong>{data.first_name }</strong>?
                    </p>
                </div>

                <hr className="bg-[#CACACA]" />
                <div className="flex justify-center gap-4">
                    <button
                        onClick={() => handleRequest("rejected", data.id)}
                        className="bg-transparent border border-[#CACACA] text-black rounded-lg h-[40px] w-full max-w-[120px] text-[14px]"
                    >
                        Reject
                    </button>
                    <button
                        onClick={() => handleRequest("approved", data.id)}
                        className="bg-gradient-to-r from-[#EF5A24] to-[#F38157] text-white font-medium rounded-lg h-[40px] w-full max-w-[120px] text-[14px]"
                    >
                        Approve
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default ConfirmWithdrawReqModal;
